import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;

class Api {
  constructor({ baseURL }) {
    this.axiosInstance = axios.create({
      baseURL,
    });

    this.axiosInstance.interceptors.response.use(
      response => response,
      (err) => {
        console.error('Error', err);
        return Promise.reject(err);
      },
    );
  }

  findWithHash(find) {
    return this.axiosInstance.post('/addresses/findWithHash', find);
  }

  updateWithHash(data) {
    return this.axiosInstance.post('/addresses/updateWithHash', data);
  }
}


export const api = new Api({ baseURL });



// WEBPACK FOOTER //
// ./src/helpers/api.js